const WhitelabelConfig = () => import('./pages/WhitelabelConfig.vue')

const whitelabelRoutes = [
  {
    path: 'whitelabel/config',
    name: 'whitelabel-config',
    component: WhitelabelConfig,
    meta: { requiresAuth: true, menuType: 'Whitelabel' },
  },
]

export default whitelabelRoutes
